/**
 * @fileoverview PUT handler for the "/companies/:company_id/all_data_ai_training_kill_switch" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdAllDataAiTrainingOptOutCacheKeys } from "./constants";
import type { PutCompanyAllDataAiTrainingOptOutProps, CompanyAllDataAiTrainingOptOutResult } from "./types";

export const putCompanyAllDataAiTrainingOptOut = reactQueryMutationAdapter(
  companiesCompanyIdAllDataAiTrainingOptOutCacheKeys,
  ({
    companyId,
    allDataAiTrainingKillSwitch,
  }: PutCompanyAllDataAiTrainingOptOutProps): Promise<CompanyAllDataAiTrainingOptOutResult> => {
    return fetch(
      `/companies/${companyId}/all_data_ai_training_kill_switch`,
      "PUT",
      {
        company_id: companyId,
        all_data_ai_training_kill_switch: allDataAiTrainingKillSwitch,
      },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
